import cx from 'classnames';
import { useFormik } from 'formik';
import { memo, useEffect } from 'react';
import { useNavigate } from 'react-router';

import classes from './Search.module.scss';
import { ISearchProps } from './Search.types';

function Search({
  nodeRef,
  icon,
  title,
  onSearch,
  setIsSearching,
  onClick,
  onClickBtn,
  onMouseDown,
  onBlur,
  onEnterSubmit,
  initialValue,
  variant = 'default',
  className,
  isSearchVacancies = false,
}: ISearchProps) {
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: { search: '' },
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(false);
      if (onEnterSubmit) {
        onEnterSubmit(values.search);
      }
    },
    validateOnChange: true,
  });

  const {
    values,
    handleChange: formikHandleChange,
    handleSubmit: formikHandleSubmit,
    handleBlur: formikHandleBlur,
    setFieldValue,
  } = formik;

  const submitForm = (value: string) => {
    onSearch(value);
  };

  const handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    formikHandleChange(event);
    submitForm(event.currentTarget.value);
  };

  const handleBlur = (event: React.FocusEvent<HTMLDivElement, Element>) => {
    formikHandleBlur(event);
    if (
      setIsSearching
      && (!event.relatedTarget || !event.relatedTarget?.className)
      && !(event.relatedTarget?.tagName === 'A')
    ) {
      setIsSearching(false);
    }
    onBlur?.();
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (isSearchVacancies) {
      if (event.key === 'Enter') {
        navigate(`/catalog-vacancies?search=${values.search.trim()}`);
      }
    }
  };

  useEffect(() => {
    void setFieldValue('search', initialValue, true);
  }, [initialValue, setFieldValue]);

  return (
    <form
      className={cx(
        classes.search,
        classes[`search--variant-${variant}`],
        className,
      )}
      onSubmit={formikHandleSubmit}
    >
      <input
        ref={nodeRef}
        className={classes.search__input}
        placeholder={title}
        type="text"
        name="search"
        value={values.search}
        onChange={handleChange}
        onBlur={handleBlur}
        onClick={onClick}
        onMouseDown={onMouseDown}
        tabIndex={0}
        autoComplete="off"
        onKeyDown={handleKeyDown}
      />

      {icon && onClickBtn ? (
        <button
          className={cx(classes.search__btn, classes.search__icon)}
          type="button"
          onClick={() => {
            if (isSearchVacancies) {
              navigate(`/catalog-vacancies?search=${values.search.trim()}`);
            } else {
              onClickBtn?.();
            }
          }}
        >
          {icon?.()}
        </button>
      ) : (
        <span className={classes.search__icon}>{icon?.()}</span>
      )}
    </form>
  );
}

export default memo(Search);
